import { store } from 'quasar/wrappers';
import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import app from './app';
import notifications from './notifications';
import chat from './chat';

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

const Store = createStore({
  modules: {
    app,
    notifications,
    chat,
  },
  plugins: [
    createPersistedState({
      key: 'quantum-app',
      paths: ['app'],
    }),
  ],

  // enable strict mode (adds overhead!)
  // for dev mode and --debug builds only
  strict: process.env.DEBUGGING,
});

export { Store };
export default store((/* { ssrContext } */) => Store);
